import { useCallback, useMemo } from "react";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useShouldInitOverlay } from "../../useShouldInitOverlay";
import { KEY } from "./constants";
export const useGoogleOneTap = () => {
    const shouldInit = useShouldInitOverlay(KEY);
    const { dispatch } = useOverlayOrchestrator();
    const onDismiss = useCallback(() => dispatch({ type: "COMPLETE", payload: KEY }), [dispatch]);
    return useMemo(() => ({
        shouldInit,
        onDismiss,
    }), [shouldInit, onDismiss]);
};
